/**
 * 配置编译环境和线上环境之间的切换
 * 
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址 history
 * 
 */

let baseUrl = '';
let routerMode = 'hash';
let imgBaseUrl = '';


if (process.env.NODE_ENV == 'development') {
    baseUrl = 'http://192.168.0.111:8080/icbc-visa';
    imgBaseUrl = '';

} else if (process.env.NODE_ENV == 'production') {
    //baseUrl = 'https://test.rellux.com.cn/icbc-visa-website';
    //baseUrl = 'http://192.168.0.111:8080/icbc-visa';
    baseUrl = 'https://icbc.rellux.com.cn/icbc-visa-website';
    imgBaseUrl = '';
    routerMode = 'hash';
    //routerMode = 'history';
}

export {
    baseUrl,
    routerMode,
    imgBaseUrl,
}


// WEBPACK FOOTER //
// ./src/config/env.js